/* eslint-disable no-plusplus, prefer-const */

/**
 * @author mrdoob / http://mrdoob.com/
 * @author jetienne / http://jetienne.com/
 */
/** @namespace */

import renderer from '@/scripts/stage/globals/renderer';

let THREEx;
THREEx = {} || THREEx;

window.THREEx = THREEx;

THREEx.RendererStats = () => {
  const container = document.createElement('div');
  container.style.cssText = 'width:80px;opacity:0.9;cursor:pointer';

  const msDiv = document.createElement('div');
  msDiv.style.cssText = 'padding:0 0 3px 3px;text-align:left;background-color:#200;';
  container.appendChild(msDiv);

  const msText = document.createElement('div');
  msText.style.cssText = 'color:#f00;font-family:Helvetica,Arial,sans-serif;font-size:9px;font-weight:bold;line-height:15px';
  msText.innerHTML = 'WebGLRenderer';
  msDiv.appendChild(msText);

  const msTexts = [];
  const nLines = 9;
  for (let i = 0; i < nLines; i++) {
    msTexts[i] = document.createElement('div');
    msTexts[i].style.cssText = 'color:#f00;background-color:#311;font-family:Helvetica,Arial,sans-serif;font-size:9px;font-weight:bold;line-height:15px';
    msDiv.appendChild(msTexts[i]);
    msTexts[i].innerHTML = '-';
  }


  let lastTime = Date.now();
  return {
    domElement: container,

    update() {
      // refresh only 30time per second
      if (Date.now() - lastTime < 1000 / 30) return;
      lastTime = Date.now();

      let i = 0;

      msTexts[i++].textContent = '== Memory =====';
      msTexts[i++].textContent = `Programs: ${renderer.info.programs.length}`;
      msTexts[i++].textContent = `Geometries: ${renderer.info.memory.geometries}`;
      msTexts[i++].textContent = `Textures: ${renderer.info.memory.textures}`;

      msTexts[i++].textContent = '== Render =====';
      msTexts[i++].textContent = `Calls: ${renderer.info.render.calls}`;
      msTexts[i++].textContent = `Triangle: ${renderer.info.render.triangles}`;
      msTexts[i++].textContent = `Points: ${renderer.info.render.points}`;
      msTexts[i++].textContent = `Lines: ${renderer.info.render.lines}`;
    },
  };
};
